import { ADDBOOKING, DELETEBOOKING } from "./actionTypes";

export const addBookings = (data) => {
 return {
  type: ADDBOOKING,
  payload: {
   bookingData: {
    from: data.from,
    to: data.to,
    date: data.date,
    guests: data.guests,
    ticketClass: data.ticketClass,
   },
  },
 };
};

export const deleteBookings = (id) => {
 return {
  type: DELETEBOOKING,
  payload: {
   id,
  },
 };
};
